import type { VehicleGroup, VehicleGroupWithPath } from '@cobliteam/common-types';

import type { VehiclesGroup } from '../../__generated__/graphql';

export const graphQLVehiclesGroupToVehicleGroup = (fuscaVehicleGroup: VehiclesGroup): VehicleGroup => ({
  id: fuscaVehicleGroup.id,
  name: fuscaVehicleGroup.name,
  createdAt: fuscaVehicleGroup.createdAt,
  updatedAt: fuscaVehicleGroup.updatedAt,
  creatorId: fuscaVehicleGroup.creatorId,
  vehicleIds: fuscaVehicleGroup.vehicles.map((v) => v.id),
});

export const graphQLVehiclesGroupToVehicleGroupWithPath = (fuscaVehicleGroup: VehiclesGroup): VehicleGroupWithPath => ({
  id: fuscaVehicleGroup.id,
  name: fuscaVehicleGroup.name,
  path: fuscaVehicleGroup.path,
});
